import { render, staticRenderFns } from "./AdminAccountSelector.vue?vue&type=template&id=1b21853b&scoped=true"
import script from "./AdminAccountSelector.vue?vue&type=script&lang=js"
export * from "./AdminAccountSelector.vue?vue&type=script&lang=js"
import style0 from "./AdminAccountSelector.vue?vue&type=style&index=0&id=1b21853b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b21853b",
  null
  
)

export default component.exports